import { render, staticRenderFns } from "./sIcon.vue?vue&type=template&id=63856bd2&scoped=true"
import script from "./sIcon.vue?vue&type=script&lang=js"
export * from "./sIcon.vue?vue&type=script&lang=js"
import style0 from "./sIcon.vue?vue&type=style&index=0&id=63856bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63856bd2",
  null
  
)

export default component.exports